<template>
  <v-container id="curriculumListingPage" class="pt-md-6 pt-5">
    <v-layout row justify-space-between class="hidden-sm-and-down">
      <v-flex xs6 ml4 lg3>
        <h1 class="h2 mb-3 cursor-pointer" @click="resetFiltersAndSearch">
          KCCTE Resource Library
        </h1>
      </v-flex>

      <v-flex xs6 ml4 lg3 class="text-xs-right">
        <v-layout row>
          <v-flex>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on">
                  <span v-html="sortByText" /> <v-icon class="ml-2">
                    arrow_drop_down
                  </v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-tile @click="sortBy = 'updatedAt'">
                  <v-list-tile-title>Last Modified</v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="sortBy = 'createdAt'">
                  <v-list-tile-title>Newest</v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="sortBy = 'az'">
                  <v-list-tile-title>A-Z</v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="sortBy = 'za'">
                  <v-list-tile-title>Z-A</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-flex>
          <v-flex>
            <v-btn-toggle v-model="listOrGrid" mandatory class="mt-2">
              <v-btn flat value="list">
                <v-icon>view_list</v-icon>
              </v-btn>
              <v-btn flat value="grid">
                <v-icon>view_module</v-icon>
              </v-btn>
            </v-btn-toggle>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout justify-content-center wrap class="hidden-md-and-up">
      <v-flex xs11 ml4 lg3>
        <h1 class="h2 mb-3">
          KCCTE Resource Library
        </h1>
        <v-flex id="curriculumCheckboxes" xs12 class="mt-4">
          <v-text-field v-model="search" label="Search" outline append-icon="search" @input="runSearch" />
        </v-flex>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn clas="mx-0" block v-on="on">
              <span v-html="sortByText" /> <v-icon class="ml-2">
                arrow_drop_down
              </v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-tile @click="sortBy = 'updatedAt'">
              <v-list-tile-title>Last Modified</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="sortBy = 'createdAt'">
              <v-list-tile-title>Newest</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="sortBy = 'az'">
              <v-list-tile-title>A-Z</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="sortBy = 'za'">
              <v-list-tile-title>Z-A</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-flex>
    </v-layout>

    <v-layout row class="pt-5">
      <v-flex id="curriculumCheckboxes" lg3 md5 class="pr-5 hidden-sm-and-down">
        <v-text-field v-model="search" label="Search" outline append-icon="search" @input="runSearch" />
        <div>
          <h3 class="cursor-pointer mb-3" @click="addOrRemoveArrayItem(listsOpen, 'resource')">
            <v-icon class="category-icon red--text text--darken-3" :class="{rotate: listsOpen.includes('resource')}">
              fas fa-angle-right
            </v-icon> Resource Type
          </h3>
          <transition name="expand" @enter="enter" @after-enter="afterEnter" @leave="leave">
            <div v-show="listsOpen.includes('resource')" class="child-items">
              <div class="mb-5">
                <v-tooltip v-for="resource in metaData.resourceTypes" :key="resource.id" bottom close-delay="10">
                  <template v-slot:activator="{ on }">
                    <label class="checkbox-button noselect" :for="'resourceType'+resource.id" v-on="on">
                      <input :id="'resourceType'+resource.id" v-model="checkboxes" :value="{key:'resourceType',value:resource.id}" type="checkbox" class="filter-checkbox checkbox-button__input" @change="checkboxChange">
                      <span class="checkbox-button__control" />
                      <div class="tag-value checkbox-button__label ml-1">
                        <v-avatar size="30px" tile class="mr-1 mb-1">
                          <v-img :src="resource.iconUrl" contain aspect-ratio="1" />
                        </v-avatar> <span>{{ resource.name | truncate(20) }}</span></div>
                    </label>
                  </template>
                  <span>{{ resource.name }}</span>
                </v-tooltip>
              </div>
            </div>
          </transition>
        </div>
        <div>
          <h3 class="cursor-pointer mb-3" @click="addOrRemoveArrayItem(listsOpen, 'grade')">
            <v-icon class="category-icon red--text text--darken-3" :class="{rotate: listsOpen.includes('grade')}">
              fas fa-angle-right
            </v-icon> Grade Level
          </h3>
          <transition name="expand" @enter="enter" @after-enter="afterEnter" @leave="leave">
            <div v-show="listsOpen.includes('grade')" class="child-items">
              <div class="mb-5">
                <v-tooltip v-for="resource in metaData.gradeLevels" :key="resource.id" bottom close-delay="10">
                  <template v-slot:activator="{ on }">
                    <label class="checkbox-button noselect" :for="'gradeLevel'+resource.id" v-on="on">
                      <input :id="'gradeLevel'+resource.id" v-model="checkboxes" :value="{key:'gradeLevel',value:resource.id}" type="checkbox" class="filter-checkbox checkbox-button__input" @change="checkboxChange">
                      <span class="checkbox-button__control" />
                      <div class="tag-value checkbox-button__label ml-1">
                        <v-avatar size="30px" tile class="mr-1 mb-1">
                          <v-img :src="resource.iconUrl" contain aspect-ratio="1" />
                        </v-avatar> <span>{{ resource.name | truncate(20) }}</span></div>
                    </label>
                  </template>
                  <span>{{ resource.name }}</span>
                </v-tooltip>
              </div>
            </div>
          </transition>
        </div>
        <div>
          <h3 class="cursor-pointer mb-3" @click="addOrRemoveArrayItem(listsOpen, 'programs')">
            <v-icon class="category-icon red--text text--darken-3" :class="{rotate: listsOpen.includes('programs')}">
              fas fa-angle-right
            </v-icon> Programs
          </h3>
          <transition name="expand" @enter="enter" @after-enter="afterEnter" @leave="leave">
            <div v-show="listsOpen.includes('programs')" class="child-items">
              <div class="mb-5">
                <v-tooltip v-for="resource in metaData.programs" :key="resource.id" bottom close-delay="10">
                  <template v-slot:activator="{ on }">
                    <label class="checkbox-button noselect" :for="'program'+resource.id" v-on="on">
                      <input :id="'program'+resource.id" v-model="checkboxes" :value="{key:'program',value:resource.id}" type="checkbox" class="filter-checkbox checkbox-button__input" @change="checkboxChange">
                      <span class="checkbox-button__control" />
                      <div class="tag-value checkbox-button__label ml-1">
                        <v-avatar size="30px" tile class="mr-1 mb-1">
                          <v-img :src="resource.iconUrl" contain aspect-ratio="1" />
                        </v-avatar> <span>{{ resource.name | truncate(20) }}</span></div>
                    </label>
                  </template>
                  <span>{{ resource.name }}</span>
                </v-tooltip>
              </div>
            </div>
          </transition>
        </div>
        <div>
          <h3 class="cursor-pointer mb-3" @click="addOrRemoveArrayItem(listsOpen, 'authors')">
            <v-icon class="category-icon red--text text--darken-3" :class="{rotate: listsOpen.includes('authors')}">
              fas fa-angle-right
            </v-icon> Authors
          </h3>
          <div>
            <transition name="expand" @enter="enter" @after-enter="afterEnter" @leave="leave">
              <div v-show="listsOpen.includes('authors')" class="child-items mb-5">
                <v-tooltip v-for="resource in metaData.authors" :key="resource.id" bottom close-delay="10">
                  <template v-slot:activator="{ on }">
                    <label class="checkbox-button noselect" :for="'author'+resource.id" v-on="on">
                      <input :id="'author'+resource.id" v-model="checkboxes" :value="{key:'author',value:resource.id}" type="checkbox" class="filter-checkbox checkbox-button__input" @change="checkboxChange">
                      <span class="checkbox-button__control" />
                      <span class="tag-value checkbox-button__label ml-1">{{ resource.fullName | truncate(20) }}</span>
                    </label>
                  </template>
                  <span>{{ resource.fullName }}</span>
                </v-tooltip>
              </div>
            </transition>
          </div>
        </div>
      </v-flex>

      <v-flex md7 lg9>
        <v-layout v-if="loading" row>
          <v-flex xs12 fill-height text-xs-center my-7>
            <v-progress-circular :size="70" :width="7" color="secondary" indeterminate />
          </v-flex>
        </v-layout>
        <v-layout v-else id="curriculumListing" wrap :justify-content-center="$vuetify.breakpoint.smAndDown">
          <v-flex v-for="item in listData" v-if="listOrGrid == 'grid' && item.colorCode" :key="item.id" xs11 lg4 class="px-3 pb-3">
            <a style="text-decoration:none" :href="'/curriculum/' + item.id">
              <v-hover>
                <v-card slot-scope="{ hover }" :class="`elevation-${hover ? 6 : 2}`">
                  <div style="height:200px;border-radius: 7px;" :style="{background: `linear-gradient(to bottom, ${item.colorCode} 0%,${lightenDarkenColor(item.colorCode, -100)} 100%)`}">
                    <v-container fill-height fluid class="p-3">
                      <v-layout fill-height>
                        <v-flex xs12 align-self-center flexbox class="text-xs-center">
                          <v-avatar v-for="(program, index) in item.programs.slice(0,3)" v-if="item.programs.length > 0" :key="program.id" size="70px" tile class="mb-3" :class="{'mr-3': [0,1].includes(index)}">
                            <v-img :src="program.iconUrl" contain aspect-ratio="1" />
                          </v-avatar>
                          <p class="white--text" v-text="item.title" />
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </div>
                  <div v-if="!item.active" class="py-2 text-center blue text-white" style="margin-top: -30px;">
                    Inactive Course
                  </div>
                  <v-card-actions class="py-4 px-4">
                    <v-tooltip v-for="resourceType in item.resourceTypes.slice(0,2)" v-if="item.resourceTypes.length > 0" :key="'resource'+resourceType.id" bottom>
                      <template v-slot:activator="{ on }">
                        <v-avatar size="30px" tile class="mr-2" v-on="on">
                          <v-img :src="resourceType.iconUrl" contain aspect-ratio="1" />
                        </v-avatar>
                      </template>
                      <span v-text="resourceType.name" />
                    </v-tooltip>
                    <v-tooltip v-if="item.resourceTypes.length >=3" bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on">
                          fas fa-chevron-circle-down
                        </v-icon>
                      </template>
                      <span>
                        <span v-for="resourceType in item.resourceTypes.slice(2)" :key="'tooltip'+resourceType.id">{{ resourceType.name }}<br></span>
                      </span>
                    </v-tooltip>
                    <v-spacer />
                    <v-tooltip v-for="gradeLevel in item.gradeLevel.slice(0,3)" v-if="item.gradeLevel.length > 0" :key="gradeLevel.id" bottom>
                      <template v-slot:activator="{ on }">
                        <v-avatar size="30px" tile class="mr-2" v-on="on">
                          <v-img :src="gradeLevel.iconUrl" contain aspect-ratio="1" />
                        </v-avatar>
                      </template>
                      <span v-text="gradeLevel.name" />
                    </v-tooltip>
                  </v-card-actions>
                </v-card>
              </v-hover>
            </a>
          </v-flex>

          <v-flex v-for="item in listData" v-if="listOrGrid == 'list' && item.colorCode" :key="item.id" xs12 class="px-3 pb-3">
            <a style="text-decoration:none" :href="'/curriculum/' + item.id">
              <v-layout row wrap pl-5 pb-5>
                <v-flex xs2>
                  <div style="border-radius: 7px;padding-bottom:100%;position: relative;" :style="{background: `linear-gradient(to bottom, ${item.colorCode} 0%,${lightenDarkenColor(item.colorCode, -100)} 100%)`}">
                    <v-container fill-height fluid class="p-3" style="position:absolute;top:0;left:0;right:0;bottom:0">
                      <v-layout fill-height>
                        <v-flex xs12 align-self-center flexbox class="text-xs-center">
                          <v-avatar v-if="item.programs.length > 0" size="70px" tile>
                            <v-img :src="item.programs[0].iconUrl" contain aspect-ratio="1" />
                          </v-avatar>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </div>

                </v-flex>
                <v-flex xs10 pl-5>
                  <div>
                    <p class="title font-weight-bold d-inline-block">
                      {{ item.title }}
                    </p>
                    <div class="d-inline-block ml-4 mr-2">
                      <v-tooltip v-for="gradeLevel in item.gradeLevel.slice(0,3)" v-if="item.gradeLevel.length > 0" :key="gradeLevel.id" bottom>
                        <template v-slot:activator="{ on }">
                          <v-avatar size="30px" tile class="mr-2" style="margin-top: -5px;" v-on="on">
                            <v-img :src="gradeLevel.iconUrl" contain aspect-ratio="1" />
                          </v-avatar>
                        </template>
                        <span v-text="gradeLevel.name" />
                      </v-tooltip>
                    </div>
                    <v-tooltip v-for="resourceType in item.resourceTypes.slice(0,2)" v-if="item.resourceTypes.length > 0" :key="resourceType.id" bottom>
                      <template v-slot:activator="{ on }">
                        <v-avatar size="30px" tile class="ml-2" style="margin-top: -5px;" v-on="on">
                          <v-img :src="resourceType.iconUrl" contain aspect-ratio="1" />
                        </v-avatar>
                      </template>
                      <span v-text="resourceType.name" />
                    </v-tooltip>
                    <v-tooltip v-if="item.resourceTypes.length >=3" bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon style="margin-top: -5px;" v-on="on">
                          fas fa-chevron-circle-down
                        </v-icon>
                      </template>
                      <span>
                        <span v-for="resourceType in item.resourceTypes.slice(2)" :key="resourceType.id">{{ resourceType.name }}<br></span>
                      </span>
                    </v-tooltip>
                  </div>
                  <p>
                    {{ item.description }}
                  </p>
                </v-flex>
              </v-layout>
            </a>
          </v-flex>
        </v-layout>
        <div class="text-center pb-5 pt-6">
          <v-pagination v-model="pagination.page" :total-visible="5" :length="pages" color="secondary" />
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import axios from 'axios';
  import debounce from 'lodash/debounce';

  export default {
    parent: true,

    data: () => ({
      listsOpen: ['resource', 'grade'],
      cancelSource: null,
      loading: true,
      listOrGrid: 'grid',
      sortBy: 'createdAt',
      search: '',
      checkboxes: [],
      listData: [],
      metaData: [],
      totalItems: 0,
      pagination: {
        descending: false, page: 1, rowsPerPage: 18, sortBy: 'createdAt',
      },
    }),
    computed: {
      sortByText() {
        switch (this.sortBy) {
          case 'updatedAt':
            return '<b>Sort By:</b>  Last Modified';
          case 'createdAt':
            return '<b>Sort By:</b>  Newest';
          default:
            return 'Click to Sort';
        }
      },

      pages() {
        if (this.pagination.rowsPerPage == null
          || this.totalItems == null
        ) return 0;

        return Math.ceil(this.totalItems / this.pagination.rowsPerPage);
      },
    },

    watch: {
      listData(val) {
        if (!(val && val.length > 0)) {
          this.pagination.page = 1;
        }
      },

      pagination: {
        handler() {
          this.getCurriculum();
        },
        deep: true,
      },

      'pagination.page': function (newVal) {
        this.replaceUrlParam('currentPage', newVal);
      },

      sortBy(newVal) {
        this.pagination.sortBy = newVal;
      },
    },

    mounted() {
      this.setParameters();
      this.getCurriculum();
    },

    methods: {
      resetFiltersAndSearch() {
        this.search = '';
        this.checkboxes = [];
        this.replaceUrlParam('tags', null);
        this.replaceUrlParam('search', null);
        this.getCurriculum();
      },

      checkboxChange() {
        this.pagination.page = 1;
        this.getCurriculum();
        let urlTagFilter = '';
        this.checkboxes.forEach((tag) => {
          urlTagFilter += `${tag.key}:${tag.value},`;
        });
        urlTagFilter = urlTagFilter.replace(/,\s*$/, '');

        this.replaceUrlParam('tags', urlTagFilter);
      },

      async getCurriculum() {
        const originalCheckboxes = this.checkboxes;
        let sortDirection;
        if (this.cancelSource) {
          this.cancelSource.cancel('Operation canceled by the user.');
        }

        if (this.pagination.sortBy !== 'az' && this.pagination.sortBy !== 'za') {
          sortDirection = this.descending ? `${this.pagination.sortBy} ASC` : `${this.pagination.sortBy} DESC`;
        } else {
          sortDirection = this.pagination.sortBy === 'az' ? 'title ASC' : 'title DESC';
        }
        this.loading = true;

        let betterTags = '';
        this.checkboxes.forEach((tag) => {
          betterTags += `&${tag.key}=${tag.value}`;
        });
        betterTags = betterTags.replace(/,\s*$/, '');
        this.cancelSource = axios.CancelToken.source();
        const { data } = await axios.get(`/api/curriculum/paged?currentPage=${this.pagination.page}&pageSize=${this.pagination.rowsPerPage}&sortDirection=${sortDirection}&keyword=${this.search}${betterTags}`, {
          cancelToken: this.cancelSource.token,
        });
        this.cancelSource = null;

        this.listData = data.searchResults.resultItems;
        this.metaData = data.filters;
        if (Number(data.searchResults.totalRecords) !== this.totalItems) {
          this.totalItems = data.searchResults.totalRecords;
        }
        this.$nextTick(() => {
          this.checkboxes = originalCheckboxes;
        });
        this.loading = false;
      },

      setParameters() {
        const urlTags = this.getUrlParameter('tags');
        if (urlTags) {
          urlTags.split(',').forEach((tag) => {
            try {
              const [key, value] = tag.split(':');
              this.checkboxes.push({
                key,
                value: isNaN(value) ? value : Number(value),
              });
            } catch (e) { }
          });
        }
        this.pagination.page = this.getUrlParameter('currentPage') == '' || this.getUrlParameter('currentPage') < 1 ? 1 : Number(this.getUrlParameter('currentPage'));
        this.keyword = decodeURIComponent(this.getUrlParameter('keyword'));
        this.search = decodeURIComponent(this.getUrlParameter('search'));
      },

      replaceUrlParam(paramName, paramValue) {
        let url = window.location.href;

        if (paramValue == null) {
          paramValue = '';
        }
        const pattern = new RegExp(`\\b(${paramName}=).*?(&|#|$)`);
        if (url.search(pattern) >= 0) {
          url = url.replace(pattern, `$1${paramValue}$2`);
          history.pushState({}, '', url);
        } else {
          url = url.replace(/[?#]$/, '');
          url = `${url + (url.indexOf('?') > 0 ? '&' : '?') + paramName}=${paramValue}`;

          history.pushState({}, '', url);
        }
      },

      getUrlParameter(sParam) {
        const sPageURL = decodeURIComponent(window.location.search.substring(1));
        const sURLVariables = sPageURL.split('&');
        let sParameterName;
        let i;

        for (i = 0; i < sURLVariables.length; i++) {
          sParameterName = sURLVariables[i].split('=');

          if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
          }
        }

        return '';
      },

      runSearch: debounce(function (e) {
        this.replaceUrlParam('search', this.search);
        this.pagination.page = 1;
        this.getCurriculum();
      }, 600),

      enter(element) {
        const { width } = getComputedStyle(element);

        element.style.width = width;
        element.style.position = 'absolute';
        element.style.visibility = 'hidden';
        element.style.height = 'auto';

        const { height } = getComputedStyle(element);

        element.style.width = null;
        element.style.position = 'relative';
        element.style.visibility = 'visible';
        element.style.height = 0;
        getComputedStyle(element).height;

        setTimeout(() => {
          element.style.height = height;
        });
      },

      afterEnter(element) {
        element.style.height = 'auto';
      },

      leave(element) {
        const { height } = getComputedStyle(element);

        element.style.height = height;

        // Force repaint to make sure the
        // animation is triggered correctly.
        getComputedStyle(element).height;

        setTimeout(() => {
          element.style.height = 0;
        });
      },

      addOrRemoveArrayItem(array, value) {
        const index = array.indexOf(value);

        if (index === -1) {
          array.push(value);
        } else {
          array.splice(index, 1);
        }
      },
    },
  };
  </script>